import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const MainGroupServiceConfig = {
  name: "MainGroup",
  annotations: []
} as ServiceConfig;